var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 298,
    viewBox: "0 0 244 298",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_3176)",
    filter: "url(#filter0_dd_0_3176)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 27,
    width: 199.75,
    height: 255,
    fill: "#FFEBCC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_0_3176)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M228.75 27H29V282H228.75V27ZM56.4476 37.6249C45.8851 37.6249 37.3226 46.1875 37.3226 56.7499V252.25C37.3226 262.812 45.8851 271.375 56.4476 271.375H201.302C211.864 271.375 220.427 262.812 220.427 252.25V56.7499C220.427 46.1875 211.864 37.6249 201.302 37.6249H56.4476Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_3176)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_0_3176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.896 177.625C170.896 203.168 150.189 223.875 124.646 223.875C99.1028 223.875 78.396 203.168 78.396 177.625C78.396 152.082 99.1028 131.375 124.646 131.375C150.189 131.375 170.896 152.082 170.896 177.625Z",
    fill: "#FFAC2F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.75 177.625C174.75 205.297 152.317 227.729 124.646 227.729C96.9739 227.729 74.5415 205.297 74.5415 177.625C74.5415 149.953 96.9739 127.521 124.646 127.521C152.317 127.521 174.75 149.953 174.75 177.625ZM124.646 223.875C150.189 223.875 170.896 203.168 170.896 177.625C170.896 152.082 150.189 131.375 124.646 131.375C99.1025 131.375 78.3957 152.082 78.3957 177.625C78.3957 203.168 99.1025 223.875 124.646 223.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.646 223.875C150.189 223.875 170.896 203.168 170.896 177.625C170.896 152.082 150.189 131.375 124.646 131.375C122.809 131.375 120.998 131.482 119.217 131.69C136.655 134.018 150.106 148.951 150.106 167.026C150.106 186.716 134.144 202.677 114.455 202.677C95.8973 202.677 80.6515 188.498 78.9597 170.383C78.5886 172.742 78.396 175.161 78.396 177.625C78.396 203.168 99.1028 223.875 124.646 223.875Z",
    fill: "#FF862F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.966 165.787C153.966 167.84 152.302 169.504 150.249 169.504C148.197 169.504 146.533 167.84 146.533 165.787C146.533 163.735 148.197 162.071 150.249 162.071C152.302 162.071 153.966 163.735 153.966 165.787Z",
    fill: "#DD7429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.115 173.22C165.115 175.273 163.451 176.937 161.399 176.937C159.346 176.937 157.682 175.273 157.682 173.22C157.682 171.168 159.346 169.504 161.399 169.504C163.451 169.504 165.115 171.168 165.115 173.22Z",
    fill: "#DD7429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.257 161.142C163.257 162.681 162.009 163.929 160.47 163.929C158.93 163.929 157.682 162.681 157.682 161.142C157.682 159.602 158.93 158.354 160.47 158.354C162.009 158.354 163.257 159.602 163.257 161.142Z",
    fill: "#DD7429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.523 189.188C165.523 192.38 162.935 194.969 159.742 194.969C156.549 194.969 153.96 192.38 153.96 189.188C153.96 185.995 156.549 183.406 159.742 183.406C162.935 183.406 165.523 185.995 165.523 189.188Z",
    fill: "#DD7429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.966 178.795C153.966 180.848 152.302 182.512 150.249 182.512C148.197 182.512 146.533 180.848 146.533 178.795C146.533 176.742 148.197 175.078 150.249 175.078C152.302 175.078 153.966 176.742 153.966 178.795Z",
    fill: "#DD7429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.683 201.232C157.683 203.284 156.019 204.948 153.966 204.948C151.913 204.948 150.25 203.284 150.25 201.232C150.25 199.179 151.913 197.515 153.966 197.515C156.019 197.515 157.683 199.179 157.683 201.232Z",
    fill: "#DD7429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.904 208.321C147.904 210.373 146.24 212.037 144.187 212.037C142.135 212.037 140.471 210.373 140.471 208.321C140.471 206.268 142.135 204.604 144.187 204.604C146.24 204.604 147.904 206.268 147.904 208.321Z",
    fill: "#DD7429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.459 195.657C148.459 197.71 146.795 199.374 144.742 199.374C142.69 199.374 141.026 197.71 141.026 195.657C141.026 193.604 142.69 191.941 144.742 191.941C146.795 191.941 148.459 193.604 148.459 195.657Z",
    fill: "#DD7429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.832 213.379C134.832 214.919 133.584 216.167 132.045 216.167C130.505 216.167 129.257 214.919 129.257 213.379C129.257 211.84 130.505 210.592 132.045 210.592C133.584 210.592 134.832 211.84 134.832 213.379Z",
    fill: "#DD7429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.958 130.638C160.958 130.638 152.149 115.59 143.195 115.199C134.241 114.807 126.628 122.596 126.628 122.596C126.628 122.596 133.532 131.02 142.486 131.411C151.44 131.803 160.958 130.638 160.958 130.638Z",
    fill: "#64AC1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.284 128.69L160.958 130.637L161.426 134.463C162.714 134.305 163.836 133.51 164.412 132.347C164.988 131.184 164.94 129.81 164.284 128.69ZM126.628 122.595C123.871 119.901 123.872 119.901 123.873 119.9L123.879 119.893L123.89 119.882L123.92 119.852C123.944 119.828 123.975 119.797 124.014 119.759C124.091 119.683 124.197 119.58 124.332 119.454C124.6 119.201 124.982 118.854 125.464 118.445C126.424 117.631 127.804 116.554 129.504 115.486C132.828 113.399 137.766 111.103 143.363 111.348C146.625 111.491 149.567 112.937 151.965 114.623C154.394 116.331 156.564 118.495 158.34 120.532C160.129 122.585 161.603 124.608 162.626 126.109C163.14 126.864 163.547 127.495 163.828 127.943C163.968 128.168 164.078 128.347 164.155 128.474C164.193 128.537 164.223 128.588 164.245 128.624L164.271 128.668L164.279 128.682L164.282 128.687L164.284 128.69C164.285 128.691 164.284 128.69 160.958 130.637C161.426 134.463 161.427 134.463 161.426 134.463L161.39 134.467L161.298 134.478C161.22 134.487 161.106 134.501 160.96 134.517C160.669 134.55 160.247 134.595 159.714 134.648C158.65 134.755 157.141 134.892 155.346 135.016C151.773 135.264 146.996 135.466 142.317 135.262C136.72 135.017 132.001 132.299 128.872 129.929C127.272 128.717 125.991 127.523 125.106 126.628C124.661 126.179 124.312 125.8 124.066 125.525C123.943 125.387 123.846 125.275 123.776 125.193C123.741 125.151 123.712 125.118 123.691 125.092L123.663 125.059L123.654 125.047L123.648 125.04C123.647 125.039 123.647 125.039 126.628 122.595ZM126.628 122.595L123.871 119.901C122.498 121.306 122.401 123.519 123.647 125.039L126.628 122.595ZM158.556 127.017C155.331 122.538 149.297 115.465 143.195 115.198C134.241 114.807 126.628 122.595 126.628 122.595C126.628 122.595 133.532 131.019 142.486 131.411C147.676 131.638 153.056 131.342 156.662 131.053C159.276 130.843 160.958 130.637 160.958 130.637C160.958 130.637 160.064 129.11 158.556 127.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.989 95.3533C171.989 95.3533 161.403 114.004 150.105 119.96C138.807 125.915 124.257 120.515 124.257 120.515C124.257 120.515 128.024 105.459 139.321 99.5031C150.619 93.5475 171.989 95.3533 171.989 95.3533Z",
    fill: "#87D623"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.341 97.2558L171.989 95.3533L172.314 91.5128C173.623 91.6235 174.786 92.3936 175.399 93.556C176.011 94.7184 175.99 96.113 175.341 97.2558ZM167.628 95.1379C170.303 95.2108 171.989 95.3533 171.989 95.3533C171.989 95.3533 171.154 96.8247 169.703 99.0729C165.986 104.829 158.23 115.677 150.105 119.96C138.807 125.915 124.257 120.515 124.257 120.515C124.257 120.515 128.024 105.459 139.322 99.5031C147.446 95.2203 160.779 94.9512 167.628 95.1379ZM124.257 120.515C120.518 119.58 120.518 119.578 120.518 119.577L120.521 119.568L120.525 119.551L120.538 119.5C120.549 119.459 120.564 119.403 120.582 119.334C120.62 119.197 120.674 119.005 120.744 118.765C120.886 118.285 121.098 117.61 121.386 116.79C121.962 115.153 122.856 112.91 124.136 110.459C126.655 105.635 130.883 99.5945 137.524 96.0936C143.984 92.6883 152.899 91.6404 159.725 91.3443C163.227 91.1924 166.355 91.2336 168.608 91.3124C169.737 91.3519 170.651 91.4009 171.288 91.4406C171.607 91.4605 171.857 91.478 172.031 91.4908C172.117 91.4972 172.185 91.5024 172.232 91.5062L172.288 91.5107L172.305 91.5121L172.314 91.5128C172.314 91.5129 172.314 91.5128 171.989 95.3533C175.341 97.2558 175.341 97.2551 175.341 97.2558L175.337 97.2634L175.329 97.2778L175.301 97.3266C175.277 97.368 175.243 97.4267 175.199 97.5019C175.112 97.6522 174.985 97.8683 174.821 98.1425C174.494 98.6908 174.018 99.4726 173.413 100.426C172.204 102.33 170.471 104.934 168.366 107.737C164.265 113.201 158.363 119.964 151.903 123.369C145.261 126.87 137.889 126.946 132.485 126.298C129.739 125.968 127.384 125.438 125.708 124.988C124.868 124.763 124.192 124.556 123.716 124.402C123.478 124.325 123.289 124.261 123.155 124.214C123.087 124.19 123.033 124.171 122.993 124.157L122.944 124.139L122.927 124.133L122.918 124.129C122.917 124.129 122.916 124.128 124.257 120.515ZM120.518 119.58L124.257 120.515L122.916 124.128C121.074 123.445 120.041 121.485 120.518 119.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.128 118.241C158.734 113.178 168.027 97.8767 168.027 97.8767C146.185 103.443 131.871 114.458 127.444 119.27C127.444 119.27 139.522 123.305 149.128 118.241Z",
    fill: "#79C01E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.199 110.47C111.157 112.104 120.792 127.521 123.472 135.352C123.696 136.005 125.49 135.322 125.303 134.751C124.212 127.524 119.829 110.177 115.011 104.396C109.362 104.731 107.212 108.885 107.199 110.47Z",
    fill: "#8C5936"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.693 114.018C104.259 113.41 103.331 111.997 103.344 110.437C103.362 108.387 104.501 106.05 106.23 104.275C108.127 102.328 110.973 100.775 114.782 100.548C116.004 100.476 117.188 100.988 117.971 101.928C119.529 103.798 120.881 106.366 122.034 109.029C123.214 111.752 124.294 114.83 125.238 117.898C127.089 123.915 128.49 130.141 129.085 133.989C129.557 136.135 128.168 137.617 127.74 138.011C127.108 138.594 126.394 138.943 125.828 139.144C125.272 139.341 124.446 139.54 123.51 139.45C122.611 139.364 120.588 138.828 119.825 136.6C118.63 133.108 115.739 127.596 112.572 122.671C111.007 120.236 109.443 118.053 108.076 116.417C107.392 115.598 106.8 114.968 106.32 114.529C105.892 114.137 105.687 114.02 105.688 114.017C105.689 114.016 105.69 114.017 105.693 114.018ZM125.303 134.751C125.302 134.743 125.3 134.735 125.299 134.727C125.174 133.901 125.006 132.944 124.8 131.889C124.466 130.178 124.031 128.208 123.513 126.114C121.546 118.168 118.385 108.445 115.011 104.396C112.143 104.566 110.177 105.721 108.934 107.024C108.705 107.264 108.5 107.51 108.319 107.755C107.549 108.798 107.204 109.838 107.198 110.47C110.054 111.649 115.863 119.999 119.885 127.501C120.824 129.252 121.665 130.957 122.349 132.514C122.744 133.414 123.086 134.263 123.364 135.044C123.401 135.148 123.437 135.251 123.472 135.352C123.695 136.005 125.49 135.322 125.303 134.751ZM121.478 135.235C121.506 135.463 121.559 135.703 121.641 135.953C121.574 135.748 121.524 135.539 121.492 135.327C121.487 135.296 121.483 135.266 121.478 135.235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.294 105.065C117.325 106.499 116.135 109.119 113.636 110.917C111.136 112.714 108.274 113.009 107.243 111.575C106.211 110.141 107.401 107.521 109.901 105.724C112.4 103.926 115.262 103.631 116.294 105.065Z",
    fill: "#C27A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.814 148.07C121.028 153.587 116.925 161.969 108.649 166.792C100.373 171.614 91.0575 171.05 87.8426 165.533C84.6277 160.015 88.7307 151.633 97.007 146.811C105.283 141.989 114.599 142.552 117.814 148.07Z",
    fill: "#FFC671"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.681 152.871C102.817 154.671 102.28 157.051 100.48 158.188C99.1067 159.055 98.0464 160.104 97.2455 161.339C96.0876 163.126 93.7011 163.635 91.9149 162.477C90.1288 161.319 89.6195 158.933 90.7773 157.146C92.2138 154.93 94.0939 153.104 96.3642 151.67C98.1639 150.533 100.544 151.071 101.681 152.871Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_0_3176",
    x: 0.384617,
    y: 0.692309,
    width: 242.673,
    height: 296.769,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8.07692,
    dy: -5.76923
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.2692
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.922969 0 0 0 0 0.920293 0 0 0 0 0.920293 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_3176"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.46154,
    dy: 4.61538
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.42308
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.921569 0 0 0 0 0.921569 0 0 0 0 0.921569 0 0 0 0.31 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_0_3176",
    result: "effect2_dropShadow_0_3176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_3176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_0_3176",
    x: 26.1667,
    y: 24.1667,
    width: 206.833,
    height: 262.083,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.708333,
    dy: 0.708333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.77083
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_3176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_3176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_3176",
    x: 52.4415,
    y: 72.1418,
    width: 157.502,
    height: 192.687,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.05
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.988285 0 0 0 0 0.690939 0 0 0 0 0.477145 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_3176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_3176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_3176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 199.75,
    height: 255,
    fill: "white",
    transform: "translate(29 27)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_3176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 185,
    fill: "white",
    transform: "translate(36 62)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedOrange);
export default __webpack_public_path__ + "static/media/redOrange.2ec976fc187e46ae9df576bc967bf9b5.svg";
export { ForwardRef as ReactComponent };